
<!-- 上传资源首页查询页面-->
<template>
  <div>
    <!-- 卡片组件 -->
    <el-card shadow="always">
      <!-- 表头部分 -->
      <div id="titleDiv">
        <el-button type="primary" size="mini" plain @click="queryBankContentAll"
          >全部</el-button
        >
        <el-button type="primary" size="mini" plain @click="queryBankContentMy"
          >我的</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          @click="queryBankContentFree"
          >免费</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          @click="queryBankContentPrice"
          >积分</el-button
        >

        <!-- 搜索输入框 -->
        <span id="spanQuery">
          <el-input
            placeholder="请输入资源名称"
            v-model="resourceRequestData.findResourceName"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryBankContentTitle"
            ></el-button>
          </el-input>
        </span>
      </div>

      <!-- 中间内容 -->
      <el-row>
        <el-col :span="18" :offset="3">
          <ul class="infinite-list" style="overflow: auto">
            <!-- 卡片标签 -->
            <el-card
              shadow="hover"
              v-for="item in resourceResponseData.dataList"
              :key="item.resourceId"
            >
              <!-- 使用table标签布局,3行 -->
              <table @click="goDetails(item.resourceId)">
                <tr>
                  <td rowspan="3" style="width: 150px">
                    <el-image
                      style="width: 150px; height: 100px"
                      :src="item.coverUrl"
                      :fit="contain"
                    ></el-image>
                  </td>
                  <th colspan="2">{{ item.resourceName }}</th>
                </tr>
                <tr>
                  <td colspan="2">
                    <!-- 标签展示 -->
                    <span style="font-size: 15px">
                      <el-tag
                        style="margin-left: 10px"
                        type="info"
                        size="mini"
                        v-for="(it, index) in item.dynamicTagList"
                        :key="index"
                      >
                        {{ it }}
                      </el-tag>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span style="font-size: small">
                      作者：{{ item.userData.nickName !==null ?  item.userData.nickName : item.userData.userName}}
                    </span>
                    <!-- 设置分割线 -->
                    <el-divider direction="vertical"></el-divider>
                    <span style="font-size: small">
                      上传时间：{{item.createtime}}
                    </span>
                    <el-divider direction="vertical"></el-divider>
                    <span style="font-size: small; margin-left: 10px">
                      积分：{{ item.price == 0 ? "免费" : item.price }}
                    </span>
                  </td>
                  <!-- 只有在我的查询页面才会进行展示，删除按钮 -->
                  <td
                    style="width: 140px"
                    v-if="resourceResponseData.findType === 1 ? true : false"
                  >

                    <el-button
                      type="danger"
                      size="mini"
                      plain
                      @click.stop="bankContentDel(item)"
                      >删除</el-button
                    >
                  </td>
                </tr>
              </table>
            </el-card>
          </ul>
        </el-col>
      </el-row>

      

      <!-- 底部页脚 -->
      <div class="block">
        <!-- <span class="demonstration">大于 7 页时的效果</span> -->
        <el-pagination
          layout="prev, pager, next"
          :total="resourceResponseData.total"
          :page-size="resourceResponseData.pageSize"
          :current-page="resourceResponseData.currentPage"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <!-- 使用布局组件 -->
  </div>
</template>

<script>
// 导入封装好的发送请求类
import { queryResource,delResource} from '@/api/resourceDownLoad/resourceDownLoad.js'


// 使用vuex仓库
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      // 控制积分弹框展示
      dialogVisible: false,
      // 查找类型
      findType: 0,

      // 请求的字段
      resourceRequestData: {
        userId: 0,
        findType: 0,
        findResourceName:'',
        pageNumber: 1,
        pageSize: 10,
      },
      // 返回的内容信息
      resourceResponseData: {
        dataList: {},
        total: 100,
        pageSize: 10,
        currentPage: 1,
        findType: 0, //将查询类型再次进行返回
      },

      // 查询是否需要积分返回值
      needPriceData: {},

      // 判断当前用户积分是否充足
      ampleData: {},
    };
  },
  computed: {},
  // 已进入页面开始执行
  created() {
    // 调用方法进行查询,第一参数是查询类型，第二个参数是当前页
    this.findResource(this.findType, 1);
  },
  methods: {

    // 对自己的内容进行删除
    async bankContentDel(delData) {
      // 先进行提示
      this.$confirm("此操作将删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        // 点击确定按钮
        // 调用封装好的方法
        const res = await delResource(delData.resourceId);
        if(res.status==='200'){
          this.$message({
            type: 'success',
            message: res.message
          });

          // 刷新当前页面
          this.$router.go(0);
        }

      });
    },

    

    // 跳转到详情页面
    async goDetails(resourceId) {
      // 进行页面跳转
        this.$router.push({
          path: `/resourceDownload/resourceDownloadDetails/${resourceId}`,
        });
    },

    

    // 查询全部
    queryBankContentAll() {
      this.findType = 0;
      this.findResource(0, 1);
    },
    // 查询我的
    queryBankContentMy() {
      this.findType = 1;
      this.findResource(1, 1);
    },
    // 查询免费
    queryBankContentFree() {
      this.findType = 2;
      this.findResource(2, 1);
    },
    // 查询积分
    queryBankContentPrice() {
      this.findType = 3;
      this.findResource(3, 1);
    },

    /**
     * title条件查
     */
    queryBankContentTitle() {
      this.findType = 0;
      this.findResource(0, 1);
    },

    // 点击页数执行方法
    handlePageChange(page) {
      console.log("获取的page:" + page);
      // 调用查询方法
      this.findResource(this.findType, page);
    },

    // 查询面试题数据方法
    async findResource(findType, page) {
      // 获取当前登录用户id
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      const userId = userData.data.userId;
      // 封装请求数据
      this.resourceRequestData.userId = userId;
      this.resourceRequestData.findType = findType;
      this.resourceRequestData.pageNumber = page;
      this.resourceRequestData.pageSize = this.resourceResponseData.pageSize;

      // 发送请求
      const res = await queryResource(this.resourceRequestData);
      // 获取status
      if (res.status === "200") {
        
        // 封装响应数据
        this.resourceResponseData.dataList = res.data.list;
        this.resourceResponseData.total = res.data.total;
        this.resourceResponseData.currentPage = page;
        this.resourceResponseData.findType = findType; //将查询类型再次封装到响应数据中

        console.log("封装好的数：" + JSON.stringify(this.resourceResponseData));
      } else {
        this.$message.error("查询失败");
      }
    },
  },
};
</script>

<style scoped>
/* 内容标题样式 */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  /* border: 1px solid #000; */
  padding: 8px;
  text-align: left;
}

/* 顶部的搜索样式 */
.el-input {
  width: 40%;
}
#spanQuery {
  margin-left: 99px;
}
#titleDiv {
  width: 100%;
  text-align: center; /* 水平居中 */
}

/* 底部分页样式 */
.block {
  text-align: center;
}

/* 布局组件样式 */
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}

/* 内部样式 */
.infinite-list .infinite-list-item {
  display: flex;
  align-items: center;

  height: 150px;
  background: #e8fef9;
  margin: 10px;
  color: #fc7dc1;
}
</style>